<template>
  <div class="container">
    <img src="../assets/logo.jpg">
    <!-- 套餐选择 -->
    <div class="pay-wrapper">
      <!-- <button v-for="(item, index) in priceList" :key="index" @click="btnClick(index, item)" class="pay-item"
        :class="[activeIndex === index ? 'active' : '']"> {{ item.fixedAmount }}元 <br /><span class="content">{{
        item.payContent }}</span> </button> -->
      <!-- 固定 -->
      <button class="pay-item" :class="[activeIndex === 0 ? 'active' : '']" @click="btnClick(fixedAmount)"> {{
        fixedAmount }}元 <br /><span class="content">{{ fixedPayContent }}</span> </button>
      <!-- 自定义 -->
      <button v-if="isCustomRecharge" class="pay-item" :class="[activeIndex === 1 ? 'active' : '']"
        @click="changeCustomRecharge">自定义金额</button>
      <div v-if="!isCustomRecharge" class="pay-item active">
        <input type="text" class="pay-input" v-model="payMoney" placeholder="请输入自定义金额"
          onkeyup="this.value=this.value.replace(/[^\0-9.]/g,'') " />
      </div>
    </div>
    <p v-if="isShowError" style="color: #fc5531;">请仔细阅读并勾选接受《热线咨询服务协议书》</p>
    <!-- 点击按钮后调起微信支付 -->
    <button class="btn btn_primary" @click="callPayment">￥{{ payMoney }} 确认支付</button>
    <div style="margin-top: 10px;">
      <input type="checkbox" name="agreeItem" id="agreeItem" value="是否同意" v-model="isChecked"
        @change="changeCheck" />我已仔细阅读并接受
      <span style="color: #71bf44;cursor: pointer;" @click="showProtocol">《热线咨询服务协议书》</span>
    </div>
    <!-- <button style="margin-top: 350px;" @click="redirectToAuth">点击授权(测试用)</button> -->
    <p class="footer-text">热线支持电话：<span style="color: #71bf44;">400-900-3556</span></p>
  </div>
</template>

<script>
import axios from 'axios';
import wx from "weixin-js-sdk";
export default {
  name: 'Pay',
  data() {
    return {
      isChecked: false,
      isShowError: false,
      isCustomRecharge: true,
      payResult: '',// 存放支付结果
      // 假设后端返回的数组对象
      priceList: [
        {
          payContent: "单次服务收费",
          fixedAmount: 100,
        }, {
          payContent: "单次服务收费",
          fixedAmount: 500,
        },
      ],
      // 默认索引 0
      activeIndex: 0,
      openId: '',//微信用户OpenId
      payMoney: 500, //金额
      fixedAmount: 500,
      fixedPayContent: '单次服务收费',
      payContent: '',
      appid: 'wx8251dccbff149cd4',// 企业号的唯一标识
      // baseUrl: 'http://172.29.99.59:12067',
      // baseUrl:'http://localhost:12067',
      baseUrl: 'https://aviatnetworks.com.cn',
    }
  },
  methods: {
    showProtocol() {
      this.$router.push('/userAgreement')
    },
    changeCheck() {
      document.getElementById('agreeItem').addEventListener('change', function () {
        if (this.checked) {
          this.isChecked = true
        } else {
          this.isChecked = false
        }
      });
    },
    changeCustomRecharge() {
      this.activeIndex = 1;
      this.isCustomRecharge = false
      this.payMoney = 0
    },
    // btnClick(index, item) {
    //   const { payContent, fixedAmount } = item
    //   this.activeIndex = index;
    //   this.payMoney = fixedAmount
    //   this.payContent = payContent;
    // },
    btnClick(fixedAmount) {
      this.activeIndex = 0;
      this.isCustomRecharge = true
      this.payMoney = fixedAmount;
    },
    redirectToAuth() {
      const { appid } = this
      const redirectUri = encodeURIComponent('https://aviatnetworks.com.cn/#/pay');
      const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
      window.location.href = authUrl;
    },
    callPayment() {
      const { baseUrl, openId, payMoney } = this
      this.isShowError = false
      if (!this.isChecked) {
        this.isShowError = true;
        return;
      }
      if (Number(payMoney) <= 0) {
        alert('支付金额需大于0')
        return;
      }
      const url = `${baseUrl}/api/aviat/wcpay/create`
      // 请求参数
      const params = {
        openId: openId || localStorage.getItem('openId'), //用户openId
        // openId: "ohkII6WQTBQ4_-XbUpUi0v82h8d4", //用户openId xiyu
        payMoney: Number(payMoney),
        payContent: `本次服务收费${payMoney}元`,
      }
      axios.post(url, params)
        .then(res => {
          const jsonData = JSON.parse(res.data.msg);
          this.confirmPayMent(jsonData);
        })
        .catch(error => {
          console.error('callPaymentError', error);
        });
    },
    confirmPayMent(data) {
      const { appId, timeStamp, nonceStr, packageVal, signType, paySign } = data
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
        "appId": appId, //公众号ID，由商户传入     
        "timeStamp": timeStamp, //时间戳，自1970年以来的秒数  
        "nonceStr": nonceStr, // 随机字符串（必填）
        "package": packageVal, // 统一下单接口返回的 prepay_id 参数值（必填）
        "signType": signType, // 签名算法类型，默认为MD5（非必填）
        "paySign": paySign,// 签名（必填）
        //微信签名 
      }, res => {
        // 支付成功
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          // this.successPayment();
          // alert('支付成功')
          this.$router.push('/pay')
          this.payResult = `支付成功！${JSON.stringify(res.err_msg)}`;
        }
        // 支付过程中取消
        if (res.err_msg == "get_brand_wcpay_request:cancel") {
          this.cancelPayment();
          this.payResult = `支付失败！${JSON.stringify(res.err_msg)}`;
        }
        // 支付失败
        if (res.err_msg == "get_brand_wcpay_request:fail") {
        }
      });
    },
    // 成功支付回调
    successPayment() {
      this.$router.push('/payResult')
    },
    // 取消支付回调
    cancelPayment() {
    },
    // 获取openId
    getOpenId() {
      const { baseUrl } = this
      const code = (new URLSearchParams(window.location.search)).get('code');
      if (code) {
        if (this.openId || localStorage.getItem('openId')) { return; }
        const url = `${baseUrl}/api/aviat/wcpay/open/id?code=${code}`
        axios.get(url).then(res => {
          if (res && res.data.msg) {
            const jsonData = JSON.parse(JSON.parse(res.data.msg));
            this.openId = jsonData.openid;
            localStorage.setItem('openId', this.openId);
          }
        }).catch(error => {
          console.error('getOpenIdError', error);
        });
      } else {
        this.redirectToAuth();
      }
    },
  },
  mounted() {
    this.getOpenId();
    this.changeCheck();
  },
  created() {
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "index";
</style>


// WEBPACK FOOTER //
// src/components/Pay.vue